<template>
  <div class="col-xl-12 right-side-block">
    <h4 class="text-uppercase">{{ $t("contact") }}</h4>
    <div class="right-side divider"></div>
    <div class="mt-6"></div>
    <span class="font-blue font-bigger font-weight-bold"> {{ $t("RailServices")}} </span><br />
    <span class="font-blue">{{ $t("Knorr-Bremse_Systeme_für_Schienenfahrzeuge_GmbH_Training_Academy") }}(R/SGF3)</span><br />
    <span class="font-blue">+49 (0) 30 9392-2223</span><br />
    <span class="font-blue">{{ $t("contact_available") }} 07:00 – 17:00 {{ $t("oclock") }}.</span>
    <p class="text-dark">
      {{ $t("Georg-Knorr_Street") }}<br />
      {{ $t("D-12681_Berlin") }}<br /><br />
      <p class="text_dark_nv">
      <a
        class="wordbreak font-grey"
        href="mailto:TrainingAcademy@knorr-bremse.com"
        >TrainingAcademy@knorr-bremse.com</a
      >
      <a
        class="font-grey"
        href="https://rail.knorr-bremse.com/de/de/"
        target="_blank"
        >rail.knorr-bremse.com</a
      >
      <a class="font-grey" href="/contact">{{ $t("to_contact_form") }}</a>
    </p>
    </p>
    <!-- <span v-if="showBuildNumber && build_number != null" class="font-grey">{{
      build_number
    }}</span> -->
  </div>
</template>

<script>
export default {
  props: {
    showBuildNumber: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },

  data() {
    return {
      build_number: null,
    };
  },

  mounted() {
    if (this.showBuildNumber) {
      this.fetchBuildNumber();
    }
  },

  methods: {
    fetchBuildNumber() {
      var _this = this;
      this.$axios
        .get("/api/app")
        .then(function (response) {
          _this.build_number = response.data;
        })
        .catch(this.onError);
    },
  },
};
</script>

<style></style>
